import { useCallback } from 'react';

import { useTracking } from '@change-corgi/core/react/tracking';

import {
	usePetitionCommentsPageData,
	usePetitionCommentsPagePaginatedData,
	usePetitionCommentsPageState,
} from 'src/app/pages/petition/comments/pageContext';
import type { Comment } from 'src/app/pages/petition/comments/pageContext';

type Result = ModelHookResult<
	{
		hasNextPage: boolean;
		comments: readonly Comment[];
		nextPageLoading: boolean;
		hasSignedPetition: boolean;
	},
	{ loadMore: () => void }
>;

export function usePageBody(): Result {
	const {
		data: { petition, hasSignedPetition },
	} = usePetitionCommentsPageData();
	const {
		data: { hasNextPage, items, nextPageLoading },
		actions: { loadMore },
	} = usePetitionCommentsPagePaginatedData();
	const track = useTracking();
	const [{ deletedComments }] = usePetitionCommentsPageState();

	return {
		data: {
			comments: items.filter(({ id }) => !deletedComments.includes(id)),
			hasNextPage,
			nextPageLoading,
			hasSignedPetition,
		},
		actions: {
			loadMore: useCallback(() => {
				loadMore();
				void track('comment_load_more', {
					comment_feed_type: 'recent',
					commentable_id: petition.id,
					commentable_type: 'Event',
				});
			}, [loadMore, petition, track]),
		},
	};
}
